import styled from 'styled-components';
import breakpoint from '~/utils/style-utils';

const getPosition = ({ sticky }) => (sticky ? 'sticky' : 'static');

const StyledSidebarHeader = styled.header`
	flex: ${({ $isNew }) => ($isNew ? `0 0 auto` : `0 1 auto`)};
	position: ${({ stickySmaller }) => getPosition({ sticky: stickySmaller })};
	top: 0;
	left: 0;

	${({ sticky }) => breakpoint.lg`
		position: ${getPosition({ sticky })};
		`}
`;

/**
 * Simple sticky (by default) sidebar header without styling
 */
const SimpleSidebarHeader = ({ children, className, sticky = true, stickySmaller = true, isNew = false }) => (
	<StyledSidebarHeader sticky={sticky} className={className} $isNew={isNew} stickySmaller={stickySmaller}>
		{children}
	</StyledSidebarHeader>
);

export default SimpleSidebarHeader;
